import { NavigationBack, Typography } from "@/components";
import { QUERY_KEYS } from "@/libraries/constant";
import { parseDate } from "@/libraries/dayjs-relative";
import { getEventQueryOptions } from "@/queries/options/calendar";
import type { CreateOrUpdateCalendarFieldSchema } from "@/schemas";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { onlineManager, useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import EventForm from "../../-components/EventForm";

export const Route = createFileRoute("/dashboard/calendar/events/$id/edit")({
	loader: ({ context, params }) => {
		if (onlineManager.isOnline() && !context.isRestoring) {
			return context.queryClient.ensureQueryData(
				getEventQueryOptions(params.id),
			);
		}
		return context.queryClient.getQueryData([QUERY_KEYS.GET_EVENT, params.id]);
	},
	component: RouteComponent,
});

function RouteComponent() {
	const eventId = Route.useParams({
		select: (s) => s.id,
	});

	const { setValue } = useFormContext<CreateOrUpdateCalendarFieldSchema>();
	const eventQuery = useSuspenseQuery(getEventQueryOptions(eventId));

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		if (eventQuery.data?.event) {
			setValue("id", eventQuery.data.event.id);
			setValue("title", eventQuery.data.event.title);
			eventQuery.data.event.description &&
				setValue("description", eventQuery.data.event.description);
			const startAt = parseDate(eventQuery.data.event.start_datetime);
			const endAt = parseDate(eventQuery.data.event.end_datetime);
			setValue("date", startAt);
			setValue("end", endAt);
		}
	}, [eventQuery.data?.event]);

	return (
		<>
			<AppBar
				position="relative"
				color="transparent"
				className="[&_*_]:text-white !bg-gradient-case !relative !z-[9999]"
			>
				<div className="container">
					<Toolbar classes={{ root: "!p-0" }}>
						<NavigationBack />
						<Typography fontWeight={700} fontSize={16}>
							Edit Event
						</Typography>
					</Toolbar>
				</div>
			</AppBar>
			<div className="flex-1 flex flex-col bg-gray-light">
				<EventForm />
			</div>
		</>
	);
}
